import i18next from 'i18next';
import { initReactI18next } from "react-i18next";

import buttonsEN from '../lang/en/buttons.json';
import buttonsES from '../lang/es/buttons.json';
import buttonsZH from '../lang/zh/buttons.json';
import buttonsVI from '../lang/vi/buttons.json';
import alertsEN from '../lang/en/alerts.json';
import alertsES from '../lang/es/alerts.json';
import alertsZH from '../lang/zh/alerts.json';
import alertsVI from '../lang/vi/alerts.json';
import contentEN from '../lang/en/content.json';
import contentES from '../lang/es/content.json';
import contentZH from '../lang/zh/content.json';
import contentVI from '../lang/vi/content.json';
import navigationEN from '../lang/en/navigation.json';
import navigationES from '../lang/es/navigation.json';
import navigationZH from '../lang/zh/navigation.json';
import navigationVI from '../lang/vi/navigation.json';
import fieldsEN from '../lang/en/fields.json';
import fieldsES from '../lang/es/fields.json';
import fieldsZH from '../lang/zh/fields.json';
import fieldsVI from '../lang/vi/fields.json';
import placeholdersEN from '../lang/en/placeholders.json';
import placeholdersES from '../lang/es/placeholders.json';
import placeholdersZH from '../lang/zh/placeholders.json';
import placeholdersVI from '../lang/vi/placeholders.json';
import validationEN from '../lang/en/validation.json';
import validationES from '../lang/es/validation.json';
import validationZH from '../lang/zh/validation.json';
import validationVI from '../lang/vi/validation.json';

i18next
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                buttons: buttonsEN,
                alerts: alertsEN,
                content: contentEN,
                navigation: navigationEN,
                fields: fieldsEN,
                placeholders: placeholdersEN,
                validation: validationEN,
            },
            es: {
                buttons: buttonsES,
                alerts: alertsES,
                content: contentES,
                navigation: navigationES,
                fields: fieldsES,
                placeholders: placeholdersES,
                validation: validationES,
            },
        },
        lng: 'en',
        fallbackLng: 'en',
        debug: false,
    });

export default i18next;
